/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Announcements_EmptyInputs */

const fr_announcements_empty = /** @type {(inputs: Announcements_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucune actualité pour le moment.`)
};

const en_announcements_empty = /** @type {(inputs: Announcements_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No news for now.`)
};

/**
* | output |
* | --- |
* | "No news for now." |
*
* @param {Announcements_EmptyInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const announcements_empty = /** @type {((inputs?: Announcements_EmptyInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Announcements_EmptyInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_announcements_empty(inputs)
	return en_announcements_empty(inputs)
});